function formatShortURL(url, sliceCharacters = 20) {
    if (url.length > 2 * sliceCharacters) {
        return url.slice(0, sliceCharacters) + "..." +
            url.slice(url.length - sliceCharacters, url.length);
    }
    else {
        return url;
    }
}

module.exports = {
    formatShortURL
}